document.addEventListener('DOMContentLoaded', () => {
  const safeStorage = {
    get(key) { try { return window.localStorage.getItem(key); } catch (_) { return null; } },
    set(key, value) { try { window.localStorage.setItem(key, value); } catch (_) {} }
  };

  document.querySelectorAll('[data-hero-slider]').forEach((slider) => {
    const slides = [...slider.querySelectorAll('[data-hero-slide]')];
    const dots = [...slider.querySelectorAll('[data-hero-dot]')];
    const pauseButton = slider.querySelector('[data-hero-pause]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const interval = Math.max(5000, Number(slider.dataset.interval || 5000));
    let active = 0;
    let paused = reducedMotion;
    let timer;
    let swipeStartX = null;
    let swipeStartY = null;

    slides.forEach((slide, index) => {
      const image = slide.querySelector('.ed-hero__media img');
      if (!image) return;
      if (index === 0) image.loading = 'eager';
      const revealImage = () => slide.classList.add('is-image-ready');
      if (image.complete && image.naturalWidth > 0) revealImage();
      else image.addEventListener('load', revealImage, { once: true });
    });

    const restart = () => {
      window.clearInterval(timer);
      if (!paused && slides.length > 1) timer = window.setInterval(() => show(active + 1), interval);
    };
    const show = (index, userInitiated = false) => {
      if (!slides.length) return;
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const image = slide.querySelector('.ed-hero__media img');
        if (i === active && image && !image.complete) image.loading = 'eager';
        slide.classList.toggle('is-active', i === active);
        slide.setAttribute('aria-hidden', i === active ? 'false' : 'true');
        slide.inert = i !== active;
      });
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === active);
        dot.setAttribute('aria-selected', i === active ? 'true' : 'false');
      });
      const nextImage = slides[(active + 1) % slides.length]?.querySelector('.ed-hero__media img');
      if (nextImage) nextImage.loading = 'eager';
      if (userInitiated) restart();
    };
    const setPaused = (value) => {
      paused = value;
      slider.classList.toggle('is-paused', paused);
      pauseButton?.setAttribute('aria-pressed', paused ? 'true' : 'false');
      if (pauseButton) { pauseButton.textContent = paused ? '▶' : 'Ⅱ'; pauseButton.setAttribute('aria-label', paused ? 'Play featured stories' : 'Pause featured stories'); }
      restart();
    };

    dots.forEach((dot, i) => dot.addEventListener('click', () => show(i, true)));
    slider.querySelector('[data-hero-prev]')?.addEventListener('click', () => show(active - 1, true));
    slider.querySelector('[data-hero-next]')?.addEventListener('click', () => show(active + 1, true));
    pauseButton?.addEventListener('click', () => setPaused(!paused));
    slider.setAttribute('tabindex', '0');
    slider.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); show(active - 1, true); }
      if (event.key === 'ArrowRight') { event.preventDefault(); show(active + 1, true); }
    });
    slider.addEventListener('pointerdown', (event) => {
      if (event.target.closest('a,button')) return;
      swipeStartX = event.clientX;
      swipeStartY = event.clientY;
      if (event.pointerType !== 'touch') slider.setPointerCapture?.(event.pointerId);
    });
    slider.addEventListener('pointerup', (event) => {
      if (swipeStartX === null || swipeStartY === null) return;
      const deltaX = event.clientX - swipeStartX;
      const deltaY = event.clientY - swipeStartY;
      swipeStartX = null;
      swipeStartY = null;
      if (Math.abs(deltaX) >= 48 && Math.abs(deltaX) > Math.abs(deltaY) * 1.25) {
        show(active + (deltaX < 0 ? 1 : -1), true);
      }
    });
    slider.addEventListener('pointercancel', () => { swipeStartX = null; swipeStartY = null; });
    slider.addEventListener('mouseenter', () => { if (!reducedMotion) window.clearInterval(timer); });
    slider.addEventListener('mouseleave', () => { if (!reducedMotion) restart(); });
    slider.addEventListener('focusin', () => window.clearInterval(timer));
    slider.addEventListener('focusout', () => { if (!reducedMotion) restart(); });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) window.clearInterval(timer);
      else if (!reducedMotion) restart();
    });
    show(0);
    setPaused(paused);
  });

  document.querySelectorAll('[data-save-article]').forEach((button) => {
    const key = `wmw-saved-${button.dataset.saveArticle}`;
    const refresh = () => {
      const saved = safeStorage.get(key) === '1';
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      button.classList.toggle('is-saved', saved);
      if (button.textContent.trim().toLowerCase().includes('save')) button.innerHTML = saved ? '✓ Saved' : '＋ Save story';
    };
    button.addEventListener('click', () => { safeStorage.set(key, safeStorage.get(key) === '1' ? '0' : '1'); refresh(); });
    refresh();
  });

  document.querySelectorAll('[data-copy-link]').forEach((button) => {
    button.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(window.location.href);
        const original = button.textContent;
        button.textContent = 'Copied';
        window.setTimeout(() => { button.textContent = original; }, 1800);
      } catch (_) { window.prompt('Copy this link:', window.location.href); }
    });
  });

  const article = document.querySelector('[data-article]');
  const progress = document.querySelector('[data-reading-progress] span');
  const continueKey = 'wmh-last-reading-v1';
  if (article && progress) {
    const updateProgress = () => {
      const start = article.offsetTop;
      const distance = Math.max(1, article.offsetHeight - window.innerHeight);
      const amount = Math.max(0, Math.min(1, (window.scrollY - start) / distance));
      progress.style.width = `${amount * 100}%`;
      const previous = (() => { try { return JSON.parse(safeStorage.get(continueKey) || '{}'); } catch (_) { return {}; } })();
      safeStorage.set(continueKey, JSON.stringify({
        url: article.dataset.articleUrl || window.location.pathname,
        title: article.dataset.articleTitle || article.querySelector('h1')?.textContent?.trim() || 'Military history story',
        image: article.dataset.articleImage || '',
        progress: Math.max(Number(previous.progress || 0), Math.round(amount * 100)),
        updated: Date.now()
      }));
    };
    updateProgress();
    window.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress, { passive: true });
  }
  const continueCard = document.querySelector('[data-continue-reading]');
  if (continueCard) {
    let lastRead = null;
    try { lastRead = JSON.parse(safeStorage.get(continueKey) || 'null'); } catch (_) {}
    const validPath = lastRead?.url && typeof lastRead.url === 'string' && lastRead.url.startsWith('/blogs/');
    if (validPath && lastRead.title) {
      const percent = Math.max(0, Math.min(100, Number(lastRead.progress || 0)));
      continueCard.querySelector('[data-continue-title]').textContent = lastRead.title;
      continueCard.querySelector('[data-continue-status]').textContent = percent >= 95 ? 'You finished this story — open it again anytime.' : `${Math.max(1, percent)}% read · Continue from your last position`;
      continueCard.querySelector('[data-continue-progress]').style.width = `${percent}%`;
      continueCard.querySelectorAll('[data-continue-link]').forEach((link) => { link.href = lastRead.url; });
      const image = continueCard.querySelector('[data-continue-image]');
      if (lastRead.image) { image.src = lastRead.image; image.alt = lastRead.title; image.closest('.ed-continue__media')?.classList.remove('has-no-image'); } else { image.closest('.ed-continue__media')?.classList.add('has-no-image'); }
      continueCard.hidden = false;
    }
    continueCard.querySelector('[data-continue-clear]')?.addEventListener('click', () => {
      safeStorage.set(continueKey, '');
      continueCard.hidden = true;
    });
  }
  if (article) {
    const articleTitle = article.querySelector('h1')?.textContent?.trim() || 'War Machine History article';
    article.querySelectorAll('.ed-prose img').forEach((image) => {
      image.loading = 'lazy';
      image.decoding = 'async';
      if (!image.alt) image.alt = `Historical illustration for ${articleTitle}`;
    });
  }

  document.querySelectorAll('.ed-card__image img, .ed-hero__media img').forEach((image) => {
    image.addEventListener('error', () => {
      const media = image.closest('.ed-card__image, .ed-hero__media');
      media?.classList.add('is-image-error');
      image.hidden = true;
    }, { once: true });
  });

  const popup = document.querySelector('[data-shop-popup]');
  if (popup) {
    const storageKey = 'wmw-workshop-popup-closed';
    const lastClosed = Number(safeStorage.get(storageKey) || 0);
    const sevenDays = 7 * 24 * 60 * 60 * 1000;
    let shown = false;
    const showPopup = () => {
      if (shown || Date.now() - lastClosed < sevenDays) return;
      shown = true;
      popup.hidden = false;
    };
    const delay = Math.max(20000, Number(popup.dataset.delay || 45000));
    window.setTimeout(showPopup, delay);
    window.addEventListener('scroll', () => {
      const scrollable = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollable > 0 && window.scrollY / scrollable >= .6) showPopup();
    }, { passive: true });
    popup.querySelector('[data-popup-close]')?.addEventListener('click', () => {
      popup.hidden = true;
      safeStorage.set(storageKey, String(Date.now()));
    });
  }

  document.querySelectorAll('.wmw-3d-stage model-viewer').forEach((model) => {
    const stage = model.closest('.wmw-3d-stage');
    const fallback = stage?.querySelector('[data-3d-fallback]');
    let ready = false;
    const markReady = () => { ready = true; stage?.classList.add('is-3d-ready'); if (fallback) fallback.hidden = true; };
    const markFailed = () => { if (!ready) { stage?.classList.add('is-3d-failed'); if (fallback) fallback.hidden = false; } };
    model.addEventListener('load', markReady, { once: true });
    model.addEventListener('error', markFailed, { once: true });
    window.setTimeout(markFailed, 6500);
  });

  document.querySelectorAll('[data-photo-swiper]').forEach((gallery) => {
    const track = gallery.querySelector('.wmw-photo-swiper');
    const slides = [...gallery.querySelectorAll('.wmw-photo-slide')];
    const dots = [...gallery.querySelectorAll('[data-photo-index]')];
    const count = gallery.querySelector('[data-photo-count]');
    let active = 0;
    let scrollTimer;

    const update = (index) => {
      active = Math.max(0, Math.min(slides.length - 1, index));
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === active));
      if (count) count.textContent = String(active + 1).padStart(2, '0');
    };
    const go = (index) => {
      const next = (index + slides.length) % slides.length;
      slides[next]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      update(next);
    };

    dots.forEach((dot, i) => dot.addEventListener('click', () => go(i)));
    gallery.querySelector('[data-photo-prev]')?.addEventListener('click', () => go(active - 1));
    gallery.querySelector('[data-photo-next]')?.addEventListener('click', () => go(active + 1));
    track?.addEventListener('scroll', () => {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(() => {
        const width = track.clientWidth || 1;
        update(Math.round(track.scrollLeft / width));
      }, 70);
    }, { passive: true });
    track?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); go(active - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); go(active + 1); }
    });
    update(0);
  });

  document.querySelectorAll('[data-gallery-five]').forEach((gallery) => {
    const images = [...gallery.querySelectorAll('.wmw-product-stage > img, .wmw-gallery5__stage > img')];
    const controls = [...gallery.querySelectorAll('[data-index]')];
    const counter = gallery.querySelector('.wmw-launch__index b span, .wmw-gallery5__count span');
    const stage = gallery.querySelector('.wmw-product-stage');
    let active = 0;
    let dragStart = null;
    let dragCurrent = null;

    const show = (index) => {
      if (!images.length) return;
      active = (index + images.length) % images.length;
      images.forEach((image, i) => image.classList.toggle('is-active', i === active));
      controls.forEach((control, i) => control.classList.toggle('is-active', i === active));
      if (counter) counter.textContent = String(active + 1).padStart(2, '0');
    };

    controls.forEach((control, i) => control.addEventListener('click', () => show(i)));
    gallery.querySelector('[data-prev]')?.addEventListener('click', () => show(active - 1));
    gallery.querySelector('[data-next]')?.addEventListener('click', () => show(active + 1));

    if (stage) {
      stage.addEventListener('pointerdown', (event) => { dragStart = event.clientX; dragCurrent = event.clientX; stage.setPointerCapture?.(event.pointerId); });
      stage.addEventListener('pointerup', (event) => {
        if (dragStart === null) return;
        const distance = event.clientX - dragStart;
        if (Math.abs(distance) > 42) show(active + (distance < 0 ? 1 : -1));
        dragStart = null; dragCurrent = null;
        images.forEach((image) => { image.style.transform = ''; });
      });
      stage.addEventListener('pointermove', (event) => {
        const box = stage.getBoundingClientRect();
        stage.style.setProperty('--mx', `${((event.clientX - box.left) / box.width) * 100}%`);
        stage.style.setProperty('--my', `${((event.clientY - box.top) / box.height) * 100}%`);
        const current = images[active];
        if (current && event.pointerType !== 'touch') {
          const x = ((event.clientX - box.left) / box.width - .5) * 3.5;
          const y = ((event.clientY - box.top) / box.height - .5) * -2.2;
          const drag = dragStart === null ? 0 : Math.max(-4, Math.min(4, (event.clientX - dragStart) / 18));
          dragCurrent = event.clientX;
          current.style.transform = `scale(1.025) rotateY(${x + drag}deg) rotateX(${y}deg) translateZ(8px)`;
        }
      });
      stage.addEventListener('pointerleave', () => {
        images.forEach((image) => { image.style.transform = ''; });
        dragStart = null;
      });
    }
    show(0);
  });

  const toc = document.querySelector('[data-article-toc]');
  const articleHeadings = [...document.querySelectorAll('.ed-prose h2')];
  if (toc && articleHeadings.length > 1) {
    const list = toc.querySelector('ol');
    articleHeadings.forEach((heading, index) => {
      if (!heading.id) heading.id = `story-section-${index + 1}`;
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      item.appendChild(link);
      list.appendChild(item);
    });
    toc.hidden = false;
    if ('IntersectionObserver' in window) {
      const links = [...toc.querySelectorAll('a')];
      const sectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          links.forEach((link) => link.classList.toggle('is-active', link.hash === `#${entry.target.id}`));
        });
      }, { rootMargin: '-20% 0px -65% 0px' });
      articleHeadings.forEach((heading) => sectionObserver.observe(heading));
    }
  }

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const revealItems = [...document.querySelectorAll('.ed-rail, .ed-subject-hub, .ed-workshop-card, .ed-newsletter, .ed-related')];
  revealItems.forEach((item) => item.classList.add('ed-reveal'));
  if (reducedMotion || !('IntersectionObserver' in window)) {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  } else {
    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
    revealItems.forEach((item) => revealObserver.observe(item));
  }

  const launch = document.querySelector('[data-launch-deadline]');
  if (!launch) return;
  const deadline = Date.parse(launch.dataset.launchDeadline);
  const countdownValues = launch.querySelectorAll('.wmw-countdown b');
  const collectorOffer = launch.querySelector('.wmw-collector-offer');

  const tick = () => {
    const seconds = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
    const values = [Math.floor(seconds / 86400), Math.floor(seconds % 86400 / 3600), Math.floor(seconds % 3600 / 60), seconds % 60];
    countdownValues.forEach((element, i) => { element.textContent = String(values[i]).padStart(2, '0'); });
    if (!seconds && collectorOffer) collectorOffer.hidden = true;
  };
  tick();
  window.setInterval(tick, 1000);

  launch.querySelectorAll('.wmw-choice input').forEach((input) => {
    input.addEventListener('change', () => {
      launch.querySelectorAll('.wmw-choice').forEach((choice) => choice.classList.remove('is-selected'));
      input.closest('.wmw-choice')?.classList.add('is-selected');
      launch.querySelector('[data-choice-name]').textContent = input.dataset.title;
      launch.querySelector('[data-choice-price]').textContent = input.dataset.price;
      document.querySelector('[data-sticky-name]')?.replaceChildren(input.dataset.title);
      document.querySelector('[data-sticky-price]')?.replaceChildren(input.dataset.price);
      if (collectorOffer) collectorOffer.hidden = input.dataset.kind !== 'collector';
    });
  });

  document.querySelector('[data-sticky-buy]')?.addEventListener('click', () => {
    const form = document.querySelector('#wmw-launch-form');
    if (form?.requestSubmit) form.requestSubmit();
  });
});
